var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v("Subscriber")]),_c('MappingTable',{staticClass:"mt-4",attrs:{"mapping":_vm.mappingTable.subscriber}}),(_vm.mappingTable.dependents.length > 0)?_c('div',[_c('span',[_vm._v("Dependents")]),_c('MappingTable',{attrs:{"mapping":_vm.mappingTable.dependents}})],1):_c('span',[_vm._v("No dependent mapping available")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }